// import { Button } from 'bootstrap'
import React, { useState, useEffect } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import { IoMdPerson } from 'react-icons/io'
import { FaLocationArrow } from 'react-icons/fa6'
import { PiMagnifyingGlass } from 'react-icons/pi'
import { MdOutlineClear } from 'react-icons/md'

const Job = () => {
  const [originalData, setOriginalData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [titleQuery, setTitleQuery] = useState('')
  const [locationQuery, setLocationQuery] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/users.json')
        if (!response.ok) {
          throw new Error('Failed to fetch data')
        }
        const data = await response.json()
        setOriginalData(data)
        setFilteredData(data)
        setLoading(false)
      } catch (error) {
        console.error('Error fetching data:', error)
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const handleFilter = () => {
    const titleQueryLowerCase = titleQuery.toLowerCase()
    // const headingQueryLowerCase = headingQuery.toLowerCase()
    const locationQueryLowerCase = locationQuery.toLowerCase()

    const filtered = originalData.filter(item => {
      const itemTitle = (item.title || '').toLowerCase()
      const itemHeading = (item.heading || '').toLowerCase()
      const itemLastDate = (item.lastDate || '').toLowerCase()
      const itemLocation = (item.location || '').toLowerCase()
      return (
        itemTitle.includes(titleQueryLowerCase) &&
        // itemHeading.includes(headingQueryLowerCase) &&
        itemLocation.includes(locationQueryLowerCase)
      )
    })

    setFilteredData(filtered)
  }

  const clearFilters = () => {
    setTitleQuery('')
    // setHeadingQuery('')
    setLocationQuery('')
    setFilteredData(originalData)
  }

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="container py-5 text-center">Loading...</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar />

      <div className='container mt-5'>
        <div className='row align-items-center'>
          <div className='col-lg-4 input-role'>
            <div className='job-find-input '>
              <IoMdPerson className='job-find-icon' />

              <input
                type='text'
                placeholder='Keyword, Role, Skill...'
                value={titleQuery}
                onChange={e => setTitleQuery(e.target.value)}
              />
            </div>
          </div>
          <div className='col-lg-4 input-location'>
            <div className='job-find-input '>
              <FaLocationArrow className='job-find-icon' />

              <input
                type='text'
                placeholder='Location'
                value={locationQuery}
                onChange={e => setLocationQuery(e.target.value)}
              />
            </div>
          </div>
          <div className='col-lg-4 input-find-clear'>
            <button type="button" className="pressable-button" onClick={handleFilter}>
              {' '}
              <PiMagnifyingGlass /> Find
            </button>
            <button
              type="button"
              className="pressable-button ms-lg-3"
              onClick={clearFilters}
              style={{ backgroundColor: '#D62C35' }}
            >
              {' '}
              <MdOutlineClear /> Clear
            </button>
          </div>
        </div>

        <div className=''>
          {filteredData.map(item => (
            <div
              className='row job-row align-items-stretch neu-morphism'
              key={item.id}
            >
              {/* TITLE */}
              <div className='col-lg-7'>
                <h3 className='job-heading'>{item.heading}</h3>
                <div className='job-info-wrapper'>
                  <div className='job-info'>
                    <p className='m-0 location'>
                      <span className='fw-semibold'>Location:</span> <br /> {item.location}
                    </p>
                    <p className='m-0 location'>
                      <span className='fw-semibold'>Hours:</span><br /> {item.hour} Per Day
                    </p>
                    <p className='m-0 role'>
                      <span className='fw-semibold'>Time Perioud:</span><br /> {item.timePeriod}</p>
                  </div>
                  <div className='job-apply'>
                    <p className='m-0 payment'> <span className='fw-semibold'>Payment:</span> {item.salary}</p>
                    <button
                      className='pressable-button rounded-0 apply-btn'
                      style={{ backgroundColor: '#F0A41E' }}
                    >
                      Do you want to apply?
                    </button>
                  </div>
                </div>

                {item.description && item.description.trim() !== '' && (
                  <div className='job-info-wrapper mt-3'>
                    <div className='job-info d-flex flex-column align-items-start'>
                      <h5 className='font-semibold'>Job Description</h5>
                      <p>{item.description}</p>
                    </div>
                  </div>
                )}


              </div>

              {/* LOCATION */}
              <div className='col-lg-4 h-auto p-0 mt-lg-0 mt-3'>
                <iframe
                  className='map h-100'
                  style={{ border: 0 }}
                  title={`Map for ${item.location}`}
                  src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBEBT9O1STei5aTy7nodtI_6FkrjjgBQNc&q=${encodeURIComponent(
                    item.address
                  )}`}
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          ))}
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default Job
